import { useCallback } from "react";

export default function PasswordActions({
  userPasswordSaving,
  setPasswordModalUser,
  setUserPasswordForm,
  setUserPasswordNotice,
  passwordModalUser,
  userPasswordForm,
  setUserPasswordSaving,
  apiBaseUrl,
  adminFetch,
  readApiJson,
  setAdminToast,
  texts
}) {
  const closeUserPasswordModal = useCallback(() => {
    if (userPasswordSaving) {
      return;
    }
    setPasswordModalUser(null);
    setUserPasswordForm({ currentPassword: "", newPassword: "", confirmPassword: "" });
    setUserPasswordNotice("");
  }, [setPasswordModalUser, setUserPasswordForm, setUserPasswordNotice, userPasswordSaving]);

  const submitUserPasswordChange = useCallback(async (event) => {
    event.preventDefault();

    if (!passwordModalUser?.id) {
      setUserPasswordNotice("User context is missing.");
      return;
    }

    const nextPassword = String(userPasswordForm.newPassword || "");
    const confirmPassword = String(userPasswordForm.confirmPassword || "");

    if (nextPassword.length < 6) {
      setUserPasswordNotice("New password must be at least 6 characters.");
      return;
    }

    if (nextPassword !== confirmPassword) {
      setUserPasswordNotice("Password confirmation does not match.");
      return;
    }

    setUserPasswordSaving(true);
    setUserPasswordNotice("");

    try {
      const body = JSON.stringify({
        newPassword: nextPassword,
        confirmPassword
      });

      const attemptPlan = [
        { method: "PATCH", url: `${apiBaseUrl}/admin/users/${passwordModalUser.id}/password` },
        { method: "PATCH", url: `${apiBaseUrl}/api/admin/users/${passwordModalUser.id}/password` },
        { method: "POST", url: `${apiBaseUrl}/admin/users/${passwordModalUser.id}/password` },
        { method: "POST", url: `${apiBaseUrl}/api/admin/users/${passwordModalUser.id}/password` }
      ];

      let response = null;
      for (let index = 0; index < attemptPlan.length; index += 1) {
        const attempt = attemptPlan[index];
        // eslint-disable-next-line no-await-in-loop
        response = await adminFetch(attempt.url, {
          method: attempt.method,
          headers: { "Content-Type": "application/json" },
          body
        });

        if (response.ok) {
          break;
        }

        if (![404, 405, 501].includes(response.status)) {
          break;
        }
      }

      const data = await readApiJson(response);
      if (!response.ok) {
        throw new Error(data.message || "Password update failed");
      }

      setAdminToast(texts.userPasswordUpdated || texts.passwordUpdated);
      closeUserPasswordModal();
    } catch (err) {
      if (err.message !== "Session expired") {
        setUserPasswordNotice(err.message || "Password update failed");
      }
    } finally {
      setUserPasswordSaving(false);
    }
  }, [
    adminFetch,
    apiBaseUrl,
    closeUserPasswordModal,
    passwordModalUser?.id,
    readApiJson,
    setAdminToast,
    setUserPasswordNotice,
    setUserPasswordSaving,
    texts.passwordUpdated,
    texts.userPasswordUpdated,
    userPasswordForm.confirmPassword,
    userPasswordForm.newPassword
  ]);

  return {
    closeUserPasswordModal,
    submitUserPasswordChange
  };
}
